import { FunctionComponent } from 'react';
import {
  OrganizationPurchaseLimitsCard,
  OrganizationPurchaseLimitsCardTranslations,
  OrganizationPurchaseLimitsEditModal,
  OrganizationPurchaseLimitsEditModalTranslations,
} from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { UserOrganizationRequest, UserOrganizationResponse } from '@cdaas/api-clients/dist/asset-user-openapi';

interface OrganizationPurchaseLimitsProps {
  organization: UserOrganizationResponse;
  showModal: boolean;
  onClickEdit: () => void;
  updateOrganizationPurchaseLimits: (values: Pick<UserOrganizationRequest, 'policies'>) => Promise<boolean>;
  cancelOrganizationPurchaseLimits: () => void;
}

export const OrganizationPurchaseLimits: FunctionComponent<OrganizationPurchaseLimitsProps> = ({
  organization,
  showModal,
  onClickEdit,
  updateOrganizationPurchaseLimits,
  cancelOrganizationPurchaseLimits,
}) => {
  const { t } = useTranslation('editOrganization');

  const organizationPurchaseLimitsCardTranslations: OrganizationPurchaseLimitsCardTranslations = {
    title: t('organizationSettingsPage.purchaseLimit.title'),
    productsVisibilityRowTitle: t('organizationSettingsPage.purchaseLimit.productsVisibilityRowTitle'),
    hideProductsInfoText: t('organizationSettingsPage.purchaseLimit.hideProductsInfoText'),
    subscriptionProductsRowTitle: t('organizationSettingsPage.purchaseLimit.subscriptionProductsRowTitle'),
    singleDevicePolicyInfoText: t('organizationSettingsPage.purchaseLimit.singleDevicePolicyInfoText'),
    noLimitsInfoText: t('organizationSettingsPage.purchaseLimit.noLimitsInfoText'),
    month: t('organizationSettingsPage.purchaseLimit.month'),
    summaryHideProductsInfoText: t('organizationSettingsPage.purchaseLimit.summaryHideProductsInfoText'),
    summaryDontHideProductsInfoText: t('organizationSettingsPage.purchaseLimit.summaryDontHideProductsInfoText'),
    summarySingleDevicePolicyInfoText: t('organizationSettingsPage.purchaseLimit.summarySingleDevicePolicyInfoText'),
    summaryNoSingleDevicePolicyInfoText: t('organizationSettingsPage.purchaseLimit.summaryNoSingleDevicePolicyInfoText'),
    summaryNoLimitsInfoText: t('organizationSettingsPage.purchaseLimit.summaryNoLimitsInfoText'),
    approvalInfoText: t('organizationSettingsPage.purchaseLimit.approvalInfoText'),
    editButton: t('organizationSettingsPage.purchaseLimit.editButton'),
  };

  const organizationPurchaseLimitsEditModalTranslations: OrganizationPurchaseLimitsEditModalTranslations = {
    modalHeading: t('organizationSettingsPage.purchaseLimitsModal.modalHeading'),
    generalInfo: t('organizationSettingsPage.purchaseLimitsModal.generalInfo'),
    productsVisibilityTitle: t('organizationSettingsPage.purchaseLimitsModal.productsVisibilityTitle'),
    procurementLimitInputLabel: t('organizationSettingsPage.purchaseLimitsModal.procurementLimitInputLabel', {
      currency: organization.locale.currency.toUpperCase(),
    }),
    procurementLimitValueNotNumberError: t('organizationSettingsPage.purchaseLimitsModal.procurementLimitValueNotNumberError'),
    month: t('organizationSettingsPage.purchaseLimitsModal.month'),
    procurementLimitSetInfo: t('organizationSettingsPage.purchaseLimitsModal.procurementLimitSetInfo'),
    procurementLimitNotSetInfo: t('organizationSettingsPage.purchaseLimitsModal.procurementLimitNotSetInfo'),
    subscritionTitle: t('organizationSettingsPage.purchaseLimitsModal.subscritionTitle'),
    singleDeviceLimitCheckboxLabel: t('organizationSettingsPage.purchaseLimitsModal.singleDeviceLimitCheckboxLabel'),
    singleDevicePolicySetInfo: t('organizationSettingsPage.purchaseLimitsModal.singleDevicePolicySetInfo'),
    singleDevicePolicyNotSetInfo: t('organizationSettingsPage.purchaseLimitsModal.singleDevicePolicyNotSetInfo'),
    saveButton: t('organizationSettingsPage.purchaseLimitsModal.saveButton'),
    cancelButton: t('organizationSettingsPage.purchaseLimitsModal.cancelButton'),
    saveApiErrorTitle: t('organizationSettingsPage.purchaseLimitsModal.saveApiErrorTitle'),
    saveApiErrorMessage: t('organizationSettingsPage.purchaseLimitsModal.saveApiErrorMessage'),
  };

  return (
    <>
      <OrganizationPurchaseLimitsCard
        translations={organizationPurchaseLimitsCardTranslations}
        organization={organization}
        onEditButtonClick={onClickEdit}
      />
      <OrganizationPurchaseLimitsEditModal
        translations={organizationPurchaseLimitsEditModalTranslations}
        organization={organization}
        onSave={updateOrganizationPurchaseLimits}
        onCancel={cancelOrganizationPurchaseLimits}
        hidden={!showModal}
      />
    </>
  );
};
